import type { AppUsageResponse } from '@/lib/types';

interface Props {
  data: AppUsageResponse | undefined;
  loading: boolean;
  onSelectApp?: (app: { key: string; label: string }) => void;
}

export function AppUsageBars({ data, loading, onSelectApp }: Props) {
  const total = data?.licenses_assigned ?? 0;
  const items = data?.items ?? [];

  return (
    <section className="panel p-6">
      <div className="mb-6 flex items-baseline justify-between">
        <div>
          <div className="label">Adopción por app</div>
          <h2 className="mt-1 text-lg font-light text-ink-50">
            ¿Dónde está aterrizando Copilot?
          </h2>
        </div>
        <div className="text-xs text-ink-500">% sobre {total} licencias</div>
      </div>
      {loading && items.length === 0 ? (
        <div className="py-8 text-center text-ink-500">Cargando…</div>
      ) : (
        <div className="space-y-3">
          {items.map((it) => {
            const pct = total ? Math.round((it.active_users / total) * 100) : 0;
            const widthPct = total ? (it.active_users / total) * 100 : 0;
            const clickable = onSelectApp && it.active_users > 0;
            return (
              <button
                key={it.app}
                type="button"
                onClick={
                  clickable
                    ? () => onSelectApp({ key: it.app, label: it.label })
                    : undefined
                }
                disabled={!clickable}
                className={`grid w-full grid-cols-[8rem_1fr_4rem] items-center gap-4 rounded-sm px-2 py-1 text-left transition-colors ${
                  clickable
                    ? 'cursor-pointer hover:bg-ink-900/40'
                    : 'cursor-default'
                }`}
              >
                <div className="text-sm text-ink-200">{it.label}</div>
                <div className="relative h-5 bg-ink-800/60">
                  <div
                    className="absolute inset-y-0 left-0 bg-ink-300/90 transition-[width] duration-300"
                    style={{ width: `${Math.max(2, widthPct)}%` }}
                  />
                  <div className="relative px-2 py-0.5 text-[0.7rem] tabular-nums text-ink-900">
                    {it.active_users}
                  </div>
                </div>
                <div className="text-right text-sm tabular-nums text-ink-400">{pct}%</div>
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
}
